import React from "react";

// Supplied brand files, used exactly as provided. Dark theme shows the
// "-dark" file, light theme the "-light" file (switched via html.light).
export function Brand({ name, height, testid, alt }) {
  return (
    <span className="brand-wrap" data-testid={testid} style={{ height }}>
      <img className="brand-img brand-dark-img" src={`/logos/${name}-dark.webp`} alt={alt} style={{ height }} />
      <img className="brand-img brand-light-img" src={`/logos/${name}-light.webp`} alt="" aria-hidden="true" style={{ height }} />
    </span>
  );
}
